import { TReduxActions } from '../../actions';

// oxlint-disable-next-line typescript/no-explicit-any
export function lastActionReducer(_: any, action: TReduxActions): TReduxActions {
  return action;
}
